module.exports = __webpack_public_path__ + "img/32.fixed_door.de29a2f0.svg";